<template lang="pug">
button.btn.btn-default.btn-xs(@click="submit") カードを削除
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    card_token: String,
    redirect_path: String
  },
  methods: {
    async submit(e){
      e.preventDefault()
      if(confirm("カードを削除します。よろしいでしょうか？")){
        await this.$store.dispatch("user/removeCard", this.card_token)
        location.href = this.redirect_path
      }
    }
  },
  async mounted(){
    await Vue.nextTick()

  },
  watch: {
  },
}
</script>
